import React, { ReactElement, useState } from 'react';
import { Container, makeStyles, Typography } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import { Close, Menu } from '@material-ui/icons';
import { menu } from '../../data';
import logoImg from '../../images/logo-new.png';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '2.5rem',
        [theme.breakpoints.down('xs')]: {
            padding: '2rem 1rem',
        },
    },
    titleLink: {
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        color: 'inherit',
        [`&:hover`]: {
            color: theme.palette.primary.dark,
        },
        [`& img`]: {
            width: 300,
            marginRight: '1rem',
            [theme.breakpoints.down('md')]: {
                width: 200,
            },
        },
    },
    titleText: {
        [theme.breakpoints.down('md')]: {
            fontSize: '1.4rem',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '1rem',
        },
    },
    linkText: {
        fontSize: '1.5rem',
        [theme.breakpoints.down('md')]: {
            fontSize: '1.2rem',
        },
    },
    navContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        width: 500,
        [`& a`]: {
            textDecoration: 'none',
            color: 'inherit',
        },
        [`& a:active`]: {
            color: theme.palette.primary.dark,
        },
        [`& a:hover`]: {
            color: theme.palette.primary.dark,
        },
        [`& a p`]: {
            marginTop: '0.3rem',
            textTransform: 'capitalize',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    activeLink: {
        [`& p `]: {
            color: theme.palette.primary.dark,
        },
    },
    menuIcon: {
        display: 'none',
        cursor: 'pointer',
        [theme.breakpoints.down('sm')]: {
            display: 'block',
        },
    },
    mobileMenu: {
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundColor: 'white',
        zIndex: 1,
        width: '100vw',
        height: '100vh',
        [`& a`]: {
            textDecoration: 'none',
            color: 'inherit',
        },
        [`& a:active`]: {
            color: theme.palette.primary.dark,
        },
        [`& a:hover`]: {
            color: theme.palette.primary.dark,
        },
    },
    closeIcon: {
        width: 40,
        height: 40,
        float: 'right',
        margin: '2rem',
        cursor: 'pointer',
    },
    mobileMenuContainer: {
        margin: '6rem 2rem',
        textAlign: 'center',
    },
    menuLink: {
        textDecoration: 'none',
        margin: '2rem 0',
        display: 'flex',
    },
    menuText: {
        borderBottom: '1px solid black',
        [`&:hover`]: {
            color: theme.palette.primary.light,
            borderBottom: `1px solid ${theme.palette.primary.light}`,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.5rem',
        },
    },
}));

function Header(): ReactElement {
    const classes = useStyles();
    const { pathname } = useLocation();
    const [showMobileMenu, setShowMobileMenu] = useState(false);

    return (
        <div className={classes.container}>
            <Link className={classes.titleLink} to="/">
                <img src={logoImg} alt="London Insulation Services" />
            </Link>
            <div className={classes.navContainer}>
                {menu.map((item) => (
                    <Link className={item.link === pathname ? classes.activeLink : ''} to={item.link} key={item.name}>
                        <Typography className={classes.linkText} component="p" variant="subtitle1">
                            {item.name}
                        </Typography>
                    </Link>
                ))}
            </div>
            <Menu onClick={(): void => setShowMobileMenu(true)} className={classes.menuIcon} />
            {showMobileMenu && (
                <div className={classes.mobileMenu}>
                    <Close onClick={(): void => setShowMobileMenu(false)} className={classes.closeIcon} />
                    <Container maxWidth="lg">
                        <div className={classes.mobileMenuContainer}>
                            {menu.map((menuItem) => (
                                <Link
                                    className={
                                        menuItem.link === pathname
                                            ? `${classes.menuLink} ${classes.activeLink}`
                                            : classes.menuLink
                                    }
                                    key={menuItem.name}
                                    to={menuItem.link}
                                    onClick={(): void => setShowMobileMenu(false)}
                                >
                                    <Typography component="p" className={classes.menuText} variant="h2">
                                        {menuItem.name}
                                    </Typography>
                                </Link>
                            ))}
                        </div>
                    </Container>
                </div>
            )}
        </div>
    );
}

export default Header;
